import { Directive, Input, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidatorFn, AbstractControl } from '@angular/forms';

import { UniversalValidators } from './universal-validators';


export class WhiteSpaceValidatorDirective implements Validator, OnInit {
    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = UniversalValidators.noWhitespace;
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[noWhitespace][formControlName],[noWhitespace][formControl],[noWhitespace][ngModel]',
    providers: [{
        provide: NG_VALIDATORS,
        // tslint:disable-next-line:no-forward-ref
        useExisting: forwardRef(() => WhiteSpaceValidatorDirective),
        multi: true
    }]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class EmptyStringValidatorDirective implements Validator, OnInit {
    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = UniversalValidators.noEmptyString;
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[noEmptyString][formControlName],[noEmptyString][formControl],[noEmptyString][ngModel]',
    providers: [{
        provide: NG_VALIDATORS,
        // tslint:disable-next-line:no-forward-ref
        useExisting: forwardRef(() => EmptyStringValidatorDirective),
        multi: true
    }]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class IsNumberValidatorDirective implements Validator, OnInit {
    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = UniversalValidators.isNumber;
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[isNumber][formControlName],[isNumber][formControl],[isNumber][ngModel]',
    providers: [{
        provide: NG_VALIDATORS,
        // tslint:disable-next-line:no-forward-ref
        useExisting: forwardRef(() => IsNumberValidatorDirective),
        multi: true
    }]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class IsInRangeValidatorDirective implements Validator, OnInit {
     minValue: number;
     maxValue: number;

    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = UniversalValidators.isInRange(this.minValue, this.maxValue);
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[isInRange][formControlName],[isInRange][formControl],[isInRange][ngModel]',
    providers: [{
        provide: NG_VALIDATORS,
        // tslint:disable-next-line:no-forward-ref
        useExisting: forwardRef(() => IsInRangeValidatorDirective),
        multi: true
    }]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'minValue': [{ type: Input },],
'maxValue': [{ type: Input },],
};
}


export class MaxValidatorDirective implements Validator, OnInit {
     max: number;

    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = UniversalValidators.max(this.max);
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[max][formControlName],[max][formControl],[max][ngModel]',
    providers: [{
        provide: NG_VALIDATORS,
        // tslint:disable-next-line:no-forward-ref
        useExisting: forwardRef(() => MaxValidatorDirective),
        multi: true
    }]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'max': [{ type: Input },],
};
}



export class MinValidatorDirective implements Validator, OnInit {
     min: number;

    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = UniversalValidators.min(this.min);
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[min][formControlName],[min][formControl],[min][ngModel]',
    providers: [{
        provide: NG_VALIDATORS,
        // tslint:disable-next-line:no-forward-ref
        useExisting: forwardRef(() => MinValidatorDirective),
        multi: true
    }]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'min': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
